module.exports = __webpack_public_path__ + "static/media/img27.13fd93ff.jpg";